import { Img, type ImgProps } from '@chakra-ui/react'

import { getPublicUrl } from '@/client/services/url'

export default function PublicImage({ src, ...props }: ImgProps): React.ReactElement {
  return <Img {...props} src={`${getPublicUrl()}${src}`} />
}
